import React from 'react';
import { Button } from '@src/components/Button';
import { sendNewIntercomMessage } from '@src/intercom';

export const AddPremiumServiceButton = props => {
  return (
    <Button onClick={() => sendNewIntercomMessage('Hi, I’m interested in promoting my job opening.')} {...props}>
      Add a Premium Service
    </Button>
  );
};
